import React from "react";
import styled, { keyframes } from "styled-components";
import Img from "gatsby-image";

const Wrapper = styled.section`
  border-top: 2px dotted ${props => props.theme.post.colors.authorBorder};
  margin: 3em 0 0;
  padding: 2em 0 0;
`;

const Text = styled.p`
  color: ${props => props.theme.post.colors.author};
  line-height: 1.4;
  margin: 0;
  strong {
    color: ${props => props.theme.post.colors.bold};
  }
`;

const Avatar = styled.div`
  border: 1px solid ${props => props.theme.post.colors.authorBorder};
  border-radius: 100%;
  float: left;
  height: 4rem;
  width: 4rem;
  margin: -0.5em 1em 0 0;

  * {
    border-radius: 100%;
    height: 4rem !important;
  }
`;

const Author = (props) => {
  const content = `<strong>${props.author.name}</strong><br />${props.author.text}`;

  return (
    <Wrapper>
      <Avatar>
        <Img
          sizes={props.author.picture.children[0].sizes}
        />
      </Avatar>
      <Text dangerouslySetInnerHTML={{ __html: content }} />
    </Wrapper>
  );
};

export default Author;



// WEBPACK FOOTER //
// ./src/components/Article/Author/Author.jsx